<template>
    <el-dialog
      :visible.sync="dialogVisible"
      width="560px"
      height="635px"
      :close-on-click-modal="false"
      custom-class="uploadDialog"
      :before-close="closeUploadVideo"
    >
      <template slot="title">
        <div class="title">上传图片故事</div>
      </template>
      <div class="content">
        <div class="uploadInfo">
          <el-form :model="infoForm" ref="infoForm" :rules="formRules" label-width="90px" class="ruleForm">
            <label
              class="el-form-item__label"
              v-if="!isEdit"
              style="
                width: 100px;
                margin-top: -5px;
                margin-bottom: 30px;
                font-size: 14px;
                padding-right: 20px;
                color: #606266;
              "
              >选择图片</label
            >
            <el-upload
              class="upload-demo"
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="picChange"
              :multiple="true"
              :limit="10"
              :on-exceed="handleExceed"
              :show-file-list="false"
              accept="image/*"
              :auto-upload="false"
              v-if="!isEdit"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                class="chooseFile"
                ><img src="../../../img/camera.png" alt="" /> 选择文件</el-button
              >
              <div class="fileNameCon">
                <span v-if="picList.length == 0" class="fileName nofile"
                >未选择任何文件</span
                >
                <span class="fileName" v-for="(pic, index) in picList" :key="index">
                  <span class="name">
                    {{ pic.name }}
                  </span>
                  <i class="el-icon-close deleteFile" @click="deleteFile(index)"></i>
                </span>
              </div>
              
              <div class="imgTip">
                作品要求为jpg、JPEG、png、HEIC格式，文件大小不大于10MB。
              </div>
            </el-upload>
                <el-form-item
                    size="small"
                    label="标题"
                    prop="title"
                    :rules="[
                    { required: true, message: '标题不能为空'},
                    { min: 1, max: 30, message: '字数在30个字以内', trigger: 'blur' }
                    ]"
                >
                  <el-input v-model="infoForm.title" placeholder="字数在30个字以内"></el-input>
                </el-form-item>
                <el-form-item
                        size="small"
                        label="描述"
                        prop="desc"
                        :rules="[
                        { min: 1, max: 150, message: '字数在150个字以内', trigger: 'blur' }
                        ]"
                >
                  <el-input  type="textarea" v-model="infoForm.desc" :rows="5"  autocomplete="off" placeholder="字数在150个字以内"></el-input>
                </el-form-item>
                <el-form-item 
                    size="small"
                    label="拍摄时间"
                    prop="time"
                    :rules="[
                    ]"
                
                >
                    <el-col>
                    <el-date-picker type="month" :editable="false"  v-model="infoForm.time" 
                    default-value="2018"
                    format="yyyy 年 MM 月" :clearable='false'
                    style="width: 100%;" ></el-date-picker>
                    </el-col>
                </el-form-item>
                <el-form-item
                    class="placeWrapper"
                    size="small"
                    label="拍摄国家"
                    prop="sid"
                    :rules="[
                    { required: true, message: '拍摄国家不能为空'},
                    ]"
                >
                  <el-select v-model="infoForm.sid" class="continentSelect" no-data-text="请选择国家">
                    <el-option  v-for="country in countryList" v-bind:key="country.$index" :label="country.cn" :value="country.sid"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                    size="small"
                    label="拍摄作者"
                    prop="user_name"
                    :rules="[
                    { required: true, message: '拍摄作者不能为空'},
                    { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                    ]"
                >
                  <el-input v-model="infoForm.user_name"  autocomplete="off"></el-input>
                </el-form-item>
                <!-- <el-form-item 
                    size="small"
                    label="作品年份"
                    prop="year"
                    :rules="[
                    { required: true, message: '作品年份不能为空'},
                    ]"
                
                >
                    <el-col>
                    <el-select v-model="infoForm.year" class="continentSelect" no-data-text="请选择作品年份">
                      <el-option  v-for="(v, i) in yearList" :key="i" :label="v.value" :value="v.value"></el-option>
                    </el-select>
                    </el-col>
                </el-form-item> -->
                <el-form-item
                    size="small"
                    label="作品类型"
                    prop="category_id"
                    :rules="[
                    ]"
                >
                    <el-select v-model="infoForm.category_id" @change="categoryChange" class="selectCon" >
                        <el-option
                          v-for="item in categoryList" 
                          v-bind:key="item.$index"
                          v-bind:label="item.category_name"
                          v-bind:value="item.category_id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    size="small"
                    label="作品话题"
                    prop="topic_id"
                    :rules="[
                    ]"
                >
                    <el-select v-model="infoForm.topic_id" no-data-text="请先选择作品类型">
                    <el-option v-for="(value, key, index) in topicList"  v-bind:key="index"  :label="value.topic_name" :value="value.topic_id"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item
                    size="small"
                    label="作品分类"
                    prop="type"
                    :rules="[
                    { required: true, message: '作品分类不能为空'},
                    ]"
                >
                    <el-select v-model="infoForm.type" no-data-text="请先选择作品分类">
                      <el-option v-for="(v, i) in typeList"  :key="i"  :label="v.value" :value="v.id"></el-option>
                    </el-select>
                </el-form-item> -->
              <el-form-item
                    size="small"
                    label="邮箱"
                    prop="email"
                    :rules="[
                    { required: true, message: '邮箱不能为空'}
                    ]"
                >
                  <el-input v-model="infoForm.email"  autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div class="footer">
              <el-button
              type="primary"
              class="submitBtn"
              v-on:click="submitPicInfo"
              >提交</el-button>
              <img src="../../../img/loading.gif" alt="" class="loading" v-show="loading">
              <span class="closeBtn" @click="closeUploadVideo">关闭</span>
            </div>
        </div>
      </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'plogdialog',
    props: ['id'],
    data: function () {
    return {
      isEdit: false,
      dialogVisible: true,
      countryList: [],
      topicList: [],
      categoryList: [],
      picList: [],
      formRules: {},
      infoForm: {
        title: '',
        category_id: '',
        topic_id: '',
        desc: '',
        time: '',
        sid:'',
        photo_cover: [],
        user_name: '',
        // year: '',
        // type: '',
        email: ''
      },
      loading: false,
      typeList: [
        {
          id: 2,
          value: '图集'
        },
        {
          id: 3,
          value: '单图'
        }
      ],
      yearList: [
        {
          value: 2015
        },
        {
          value: 2016
        },
        {
          value: 2017
        },
        {
          value: 2018
        }
      ]
    };
  },
  created() {
    this.picList = []
    if(this.id) {
      this.editVideo(this.id)
    }
    this.getCountryList()
    this.getCategoryList()
  },
  methods: {
    editVideo(id) {
      this.$utils.get('/works/getInfo', {
        works_id: id
      }).then(res => {
        this.isEdit = true
        let data = res.data
        var time = new Date(data.time*1000)
        this.infoForm.works_id = data.works_id
        this.infoForm.title = data.title
        this.infoForm.desc = data.desc
        this.infoForm.time = time
        this.infoForm.sid = data.sid
        this.infoForm.category_id = data.category_id
        this.infoForm.topic_id = data.topic_id
        this.infoForm.user_name = data.user_name
        // this.infoForm.year = data.year
        // this.infoForm.type = data.type
        this.infoForm.email = data.email
        this.getTopicList(this.infoForm.category_id)
      })
    },
    deleteFile(index) {
      this.picList.splice(index, 1)
    },
    picChange(file) {
      console.log(file)
      if(this.picList.length > 10) {
        this.$message.warning(`当前限制选择 10 个文件`);
        return
      }
      if (!/\.(jpg|JPG|JPEG|HEIC|png|heic)$/.test(file.name)) {
        this.$message.warning(`图片格式为jpg、JPEG、png、HEIC,${file.name}文件格式不符合`);
        return
      } else {
        if (file.size / 1024 > 15240) {
          alert("图片大小不能超过15M");
        } else {
          this.picList.push(file);
        }
      }
    },
    handleExceed() {
      this.$message.warning(`当前限制选择 10 个文件`);
    },
    uploadPhotos() {
      let picParams = new FormData();
      if (this.picList.length > 0 || this.isEdit) {
        this.picList.forEach((e, index) => {
          picParams.append('images['+index+']', e.raw);
        })
        if(this.isEdit) {
          this.$utils.postJson('/works/edit', this.infoForm).then(res => {
            console.log(res)
            if(res.code == 1000) {
              this.$message.success(`保存成功！`);
              this.infoForm = {
              title: '',
              category_id: '',
              topic_id: '',
              desc: '',
              time: '',
              sid:'',
              photo_cover: [],
              cover_url: '',
              user_name: '',
              // year: '',
              type: '',
              email: ''
            }
            this.$parent.getMyPhotoList()
            this.$parent.closeDialog()
            } else {
              this.$message.warning(`${res.msg}`);
            }
          })
          return
        }

        this.$utils
          .postFile("/user/upload/create-images", picParams)
          .then((res) => {
            if (res.code == 1000) {
              this.infoForm.photo_cover = []
              if(res.data instanceof Array) {
                res.data.forEach(e => {
                  this.infoForm.photo_cover.push(e.url)
                })
              }
              if(!this.infoForm.cover_url) {
                this.infoForm.cover_url = this.infoForm.photo_cover[0]
              }
              var url = '/works/api/submit-history-photo'
              if(this.isEdit) {
                url = '/works/api/edit'
              }
              this.$utils.postJson(url, this.infoForm).then(res => {
                if(res.code == 1000) {
                  this.$message.success(`保存成功！`);
                  this.infoForm = {
                  title: '',
                  category_id: '',
                  topic_id: '',
                  desc: '',
                  time: '',
                  sid:'',
                  photo_cover: [],
                  cover_url: '',
                  user_name: '',
                  // year: '',
                  type: '',
                  email: ''
                }
                this.$parent.getMyPhotoList()
                this.$parent.closeDialog()
                } else {
                  this.$message.warning(`${res.msg}`);
                }
                this.loading = false
              })
            } else {
              this.$message.warning(`${res.msg}`);
              this.loading = false
            }
          });
      } else {
        this.$message.warning(`请选择图片`);
      }
    },
    submitPicInfo() {
      this.$refs['infoForm'].validate((valid) => {
        if(valid) {
          if(this.picList.length>0 || this.isEdit) {
            this.loading = true
            this.uploadPhotos()
          } else {
            this.$message.warning(`请选择图片`)
            return
          }
          
        }
      })
    },
    closeUploadVideo() {
      this.$confirm('您确定要取消上传吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$parent.closeDialog()
      })
    },
    getCountryList() {
      this.$utils.get('/user/get-country-list').then(res => {
        console.log(res)
        this.countryList = res.data
      })
    },
        // 获取话题列表
    getTopicList(category_id) {
      this.$utils.get('/works/getTopic', {
        category_id
      }).then(res => {
        this.topicList = res.data
      })
    },
    // 获取分类列表
    getCategoryList() {
      this.$utils.get('/works/getCategory').then(res => {
        console.log(res)
        this.categoryList = res.data
      })
    },
    categoryChange(id) {
      if(id) {
        this.getTopicList(id)
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.videoUploadCon {
  .add {
    width: 360px;
    height: 226px;
    background-color: #e6eaf0;
    border: 3px solid #bfcada;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    img {
      margin-top: 50px;
    }
  }
  .uploadDialog {
      .title {
        color: #f64109;
        font-size: 18px;
      }
      .chooseFile {
        background-color: #fff;
        border: 1px solid #ccc;
        color: #666;
        vertical-align: middle;
        img {
          vertical-align: bottom;
          margin-right: 5px;
        }
      }
      .chooseFile:hover {
        border: 1px solid rgb(83, 51, 51);
      }
      .fileNameCon {
        display: inline-block;
        vertical-align: top;
      }
      .fileName {
        display: block;
        margin-left: 15px;
        color: #999;
        line-height: 1.2;
        margin-bottom: 5px;
        .name {
          display: inline-block;
          width: 140px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      .nofile {
        margin-top: 10px;
      }
      .deleteFile {
        cursor: pointer;
        margin-left: 15px;
      }
      .imgTip {
        font-size: 14px;
        color: #999;
        line-height: 1.4;
        margin-left: 100px;
        margin-top: 24px;
        padding-bottom: 20px;
      }
      .stepInfo {
        width: 100%;
        height: 62px;
        line-height: 62px;
        background-color: rgba(183, 183, 183, 0.36);
        span {
          font-size: 16px;
          color: #999;
          margin-right: 15px;
          margin-left: 15px;
        }
        .currentStep {
          color: #282828;
        }
      }
      .uploadVideoPic,
      .uploadVideoContent {
        margin-top: 35px;
        .chooseFile {
          background-color: #fff;
          border: 1px solid #ccc;
          color: #666;
          vertical-align: middle;
          img {
            vertical-align: bottom;
            margin-right: 5px;
          }
        }
        .chooseFile:hover {
          border: 1px solid #999;
        }
        .fileName {
          margin-left: 15px;
          color: #999;
        }
        .imgTip {
          font-size: 14px;
          color: #999;
          margin-left: 110px;
          margin-top: 24px;
          padding-bottom: 43px;
          margin-bottom: 20px;
        }
      }
      .uploadVideoContent {
        margin-top: 35px;
      }
      .uploading {
        text-align: center;
        padding-bottom: 20px;
        .gif {
        }
      }
      .ruleForm {
        width: 500px;
        padding-bottom: 27px;
        margin: 27px auto 0;
      }
      .footer {
        width: 100%;
        height: 77px;
        background-color: #faf6f4;
        .submitBtn {
          background-color: #f8683b;
          border: 1px solid #dc8800;
          margin-top: 20px;
          margin-left: 25px;
        }
        .loading {
          vertical-align: top;
          margin-top: 25px;
          margin-left: 10px;
        }
        .closeBtn {
          margin-left: 15px;
          color: #999;
          cursor: pointer;
        }
      }
  }
}
</style>
